(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awaakii-health"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      if (!scope || scope.dataset.healthImagesReady === 'true') return;
      scope.dataset.healthImagesReady = 'true';
      const demo = scope.querySelector('[data-agent-demo]');
      const tabs = Array.from(scope.querySelectorAll('[data-agent-step]'));
      if (!demo || !tabs.length) return;

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const state = tab.dataset.agentStep;
          demo.dataset.agentState = state;
          demo.setAttribute('aria-labelledby', tab.id);
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          scope.querySelectorAll('[data-agent-state-step]').forEach((step) => step.classList.toggle('is-active', step.dataset.agentStateStep === state));
        });

        tab.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (next === null) return;
          event.preventDefault();
          tabs[next].click();
          tabs[next].focus();
        });
      });
    };

    document.querySelectorAll('[data-health-image-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-health-image-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awaakii-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.phoneReady === 'true') return;
      root.dataset.phoneReady = 'true';
      const slides = [...root.querySelectorAll('[data-phone-slide]')];
      const tabs = [...root.querySelectorAll('[data-phone-tab]')];
      const copies = [...root.querySelectorAll('[data-phone-copy]')];
      const screen = root.querySelector('[data-phone-screen]');
      const stage = root.querySelector('[data-phone-stage]');
      const status = root.querySelector('[data-phone-status]');
      if (!slides.length || !screen) return;
      const interval = Number(root.dataset.phoneInterval) || 6000;
      const autoplay = root.dataset.phoneAutoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.style.setProperty('--phone-duration', `${interval}ms`);
      let active = 0;
      let timer = 0;
      let startX = null;
      let pointerId = null;
      const schedule = () => {
        clearTimeout(timer);
        if (autoplay && !root.matches(':hover') && document.visibilityState === 'visible') timer = setTimeout(() => show(active + 1), interval);
      };
      const show = (next, focusTab = false) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
          const video = slide.querySelector('video');
          if (video) {
            if (selected) video.play().catch(() => {});
            else video.pause();
          }
        });
        tabs.forEach((tab, index) => {
          const selected = index === active;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          const progress = tab.querySelector('i');
          if (selected && progress) { progress.style.animation = 'none'; void progress.offsetWidth; progress.style.animation = ''; }
        });
        copies.forEach((copy, index) => {
          const selected = index === active;
          copy.classList.toggle('is-active', selected);
          copy.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        if (status && tabs[active]) status.textContent = tabs[active].dataset.phoneLabel || '';
        if (focusTab && tabs[active]) tabs[active].focus();
        schedule();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => show(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); show(active + 1, true); }
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); show(active - 1, true); }
        });
      });
      screen.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        startX = event.clientX;
        pointerId = event.pointerId;
        screen.setPointerCapture?.(pointerId);
        screen.classList.add('is-dragging');
        clearTimeout(timer);
      });
      screen.addEventListener('pointermove', (event) => {
        if (startX === null || event.pointerId !== pointerId) return;
        const distance = Math.max(-90, Math.min(90, event.clientX - startX));
        screen.style.setProperty('--phone-drag-x', `${distance}px`);
      });
      const finishDrag = (event) => {
        if (startX === null || event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        startX = null;
        pointerId = null;
        screen.classList.remove('is-dragging');
        screen.style.removeProperty('--phone-drag-x');
        if (Math.abs(distance) > 38) show(active + (distance < 0 ? 1 : -1)); else schedule();
      };
      screen.addEventListener('pointerup', finishDrag);
      screen.addEventListener('pointercancel', finishDrag);
      if (stage && matchMedia('(pointer:fine)').matches) {
        stage.addEventListener('pointermove', (event) => {
          if (screen.classList.contains('is-dragging')) return;
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          stage.style.setProperty('--phone-rotate-y', `${x * 8}deg`);
          stage.style.setProperty('--phone-rotate-x', `${y * -6}deg`);
        });
        stage.addEventListener('pointerleave', () => {
          stage.style.setProperty('--phone-rotate-y', '0deg');
          stage.style.setProperty('--phone-rotate-x', '0deg');
        });
      }
      root.addEventListener('mouseenter', () => clearTimeout(timer));
      root.addEventListener('mouseleave', schedule);
      document.addEventListener('visibilitychange', schedule);
      show(0);
    };
    document.querySelectorAll('[data-phone-showcase]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-phone-showcase]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awaakii-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.storyReady === 'true') return;
      root.dataset.storyReady = 'true';
      const slides = [...root.querySelectorAll('[data-story-slide]')];
      const dots = [...root.querySelectorAll('[data-story-dot]')];
      const copySets = [...root.querySelectorAll('[data-story-copy]')];
      const restartCopy = () => {
        root.classList.remove('is-copy-active');
        void root.offsetWidth;
        requestAnimationFrame(() => root.classList.add('is-copy-active'));
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) { restartCopy(); observer.disconnect(); } });
      }, { threshold: .3 });
      observer.observe(root);
      const applyContentPosition = (index) => {
        const second = index === 1;
        const x = second ? root.dataset.storyXTwo : root.dataset.storyXOne;
        const y = second ? root.dataset.storyYTwo : root.dataset.storyYOne;
        root.style.setProperty('--why-content-x', `${x || 50}%`);
        root.style.setProperty('--why-content-y', `${y || 50}%`);
        copySets.forEach((copy, copyIndex) => {
          const selected = copyIndex === index;
          copy.classList.toggle('is-active', selected);
          copy.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
      };
      applyContentPosition(0);
      if (slides.length < 2) return;
      const interval = Number(root.dataset.storyInterval) || 6000;
      const autoplay = root.dataset.storyAutoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = 0;
      let timer = 0;
      let pointerStart = null;
      let pointerId = null;
      const schedule = () => {
        clearTimeout(timer);
        if (autoplay && !root.matches(':hover') && document.visibilityState === 'visible') timer = window.setTimeout(() => show(active + 1), interval);
      };
      const show = (next) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, index) => {
          const selected = index === active;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
          const bar = dot.querySelector('span');
          if (selected && bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        applyContentPosition(active);
        restartCopy();
        schedule();
      };
      root.querySelector('[data-story-prev]')?.addEventListener('click', () => show(active - 1));
      root.querySelector('[data-story-next]')?.addEventListener('click', () => show(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      root.addEventListener('mouseenter', () => { root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('mouseleave', () => { root.classList.remove('is-paused'); schedule(); });
      root.addEventListener('focusin', () => { root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('focusout', () => { root.classList.remove('is-paused'); schedule(); });
      root.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.target.closest('a,button')) return;
        pointerStart = event.clientX;
        pointerId = event.pointerId;
        root.setPointerCapture?.(pointerId);
        root.classList.add('is-dragging');
        root.classList.add('is-paused');
        clearTimeout(timer);
      });
      root.addEventListener('pointermove', (event) => {
        if (pointerStart === null || event.pointerId !== pointerId) return;
        const distance = Math.max(-140, Math.min(140, event.clientX - pointerStart));
        root.style.setProperty('--why-drag-x', `${distance}px`);
      });
      const finishDrag = (event) => {
        if (pointerStart === null || event.pointerId !== pointerId) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        pointerId = null;
        root.classList.remove('is-dragging');
        root.classList.remove('is-paused');
        root.style.removeProperty('--why-drag-x');
        if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
        else schedule();
      };
      root.addEventListener('pointerup', finishDrag);
      root.addEventListener('pointercancel', finishDrag);
      document.addEventListener('visibilitychange', schedule);
      show(0);
    };
    document.querySelectorAll('[data-story-slider]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-story-slider]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awaakii-technology"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      if (!scope || scope.dataset.pointsReady === 'true') return;
      scope.dataset.pointsReady = 'true';
      scope.querySelectorAll('.technology-point').forEach((card) => {
        card.addEventListener('pointermove', (event) => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--point-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--point-y', `${event.clientY - rect.top}px`);
        });
      });
    };
    document.querySelectorAll('.technology-points-section').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.technology-points-section')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awaakii-wellness-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      if (!scope || scope.dataset.wellnessReady === 'true') return;
      scope.dataset.wellnessReady = 'true';
      scope.querySelectorAll('[data-wellness-card]').forEach((card) => {
        card.addEventListener('pointermove', (event) => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--pointer-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--pointer-y', `${event.clientY - rect.top}px`);
        });
      });
    };
    document.querySelectorAll('[data-wellness-mosaic]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-wellness-mosaic]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-h3-intro"] && !Shopify.designMode) return;
  try {
    
  (()=>{const instances=new WeakMap();const resolveRoot=(target)=>target?.matches?.('[data-h3-intro-slider]')?target:target?.querySelector?.('[data-h3-intro-slider]');const init=(root)=>{if(!root||instances.has(root))return;document.body.classList.add('is-ring-h3');const slides=[...root.querySelectorAll('[data-h3-intro-slide]')],dots=[...root.querySelectorAll('[data-h3-intro-dot]')];if(!slides.length)return;const controller=new AbortController(),signal=controller.signal,reduced=matchMedia('(prefers-reduced-motion:reduce)').matches,autoplay=root.dataset.h3Autoplay==='true'&&!reduced,interval=Number(root.dataset.h3Interval)||7000;let active=0,timer=0,inView=true,hovered=false,focused=false,editing=false,startX=null,startY=null,pointerId=null,dragging=false;const restartCopy=(slide)=>{slide.classList.remove('is-copy-active');void slide.offsetWidth;requestAnimationFrame(()=>slide.classList.add('is-copy-active'))};const paused=()=>hovered||focused||editing||!inView||document.visibilityState!=='visible';const schedule=()=>{clearTimeout(timer);if(autoplay&&slides.length>1&&!paused())timer=setTimeout(()=>show(active+1),interval)};const show=(next)=>{active=(next+slides.length)%slides.length;slides.forEach((slide,index)=>{const selected=index===active;slide.classList.toggle('is-active',selected);slide.setAttribute('aria-hidden',selected?'false':'true');if(selected)restartCopy(slide);else slide.classList.remove('is-copy-active')});dots.forEach((dot,index)=>{const selected=index===active;dot.classList.toggle('is-active',selected);if(selected)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});root.style.removeProperty('--h3-drag-x');schedule()};dots.forEach((dot,index)=>dot.addEventListener('click',()=>show(index),{signal}));root.addEventListener('mouseenter',()=>{hovered=true;clearTimeout(timer)},{signal});root.addEventListener('mouseleave',()=>{hovered=false;root.style.setProperty('--h3-drag-x','0px');schedule()},{signal});root.addEventListener('focusin',()=>{focused=true;clearTimeout(timer)},{signal});root.addEventListener('focusout',()=>{focused=false;schedule()},{signal});root.addEventListener('pointerdown',(event)=>{if(event.button!==0||event.target.closest('a,button')||slides.length<2)return;startX=event.clientX;startY=event.clientY;pointerId=event.pointerId;dragging=false;root.setPointerCapture?.(pointerId);clearTimeout(timer)},{signal});root.addEventListener('pointermove',(event)=>{if(startX===null||event.pointerId!==pointerId)return;const dx=event.clientX-startX,dy=event.clientY-startY;if(!dragging&&Math.abs(dx)>9&&Math.abs(dx)>Math.abs(dy)*1.15){dragging=true;root.classList.add('is-dragging')}if(!dragging)return;if(event.cancelable)event.preventDefault();root.style.setProperty('--h3-drag-x',`${Math.max(-140,Math.min(140,dx))}px`)},{signal});const finish=(event)=>{if(startX===null||event.pointerId!==pointerId)return;const dx=event.clientX-startX,wasDragging=dragging;startX=null;startY=null;pointerId=null;dragging=false;root.classList.remove('is-dragging');root.style.removeProperty('--h3-drag-x');if(wasDragging&&Math.abs(dx)>45)show(active+(dx<0?1:-1));else schedule()};root.addEventListener('pointerup',finish,{signal});root.addEventListener('pointercancel',finish,{signal});document.addEventListener('visibilitychange',schedule,{signal});const observer=new IntersectionObserver((entries)=>{inView=entries[0]?.isIntersecting??true;schedule()},{threshold:.16});observer.observe(root);const instance={show,schedule,slides,setEditing:(value)=>{editing=value;if(value)clearTimeout(timer);else schedule()},destroy:()=>{clearTimeout(timer);observer.disconnect();controller.abort()}};instances.set(root,instance);show(0)};document.querySelectorAll('[data-h3-intro-slider]').forEach(init);document.addEventListener('shopify:section:load',(event)=>init(resolveRoot(event.target)));document.addEventListener('shopify:section:unload',(event)=>{const root=resolveRoot(event.target),instance=root&&instances.get(root);instance?.destroy();if(root)instances.delete(root)});document.addEventListener('shopify:block:select',(event)=>{const block=document.querySelector(`[data-h3-intro-slider] [data-block-id="${event.detail.blockId}"]`),root=block?.closest('[data-h3-intro-slider]'),instance=root&&instances.get(root);if(!block||!instance)return;instance.setEditing(true);instance.show(instance.slides.indexOf(block))});document.addEventListener('shopify:block:deselect',(event)=>{const root=event.target?.closest?.('[data-h3-intro-slider]')||resolveRoot(event.target),instance=root&&instances.get(root);instance?.setEditing(false)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-h3-narrative"] && !Shopify.designMode) return;
  try {
    
  (()=>{const instances=new WeakMap();const init=(root)=>{if(!root||instances.has(root))return;const moments=[...root.querySelectorAll('[data-h3-moment]')],buttons=[...root.querySelectorAll('[data-h3-nav]')],sideCopies=[...root.querySelectorAll('[data-h3-side-copy]')],count=root.querySelector('[data-h3-count]');if(!moments.length)return;const activate=(index)=>{index=Math.max(0,Math.min(index,moments.length-1));moments.forEach((moment,i)=>moment.classList.toggle('is-active',i===index));buttons.forEach((button,i)=>button.classList.toggle('is-active',i===index));sideCopies.forEach((copy,i)=>{const active=i===index;copy.classList.toggle('is-active',active);copy.hidden=!active});if(count)count.textContent=String(index+1).padStart(2,'0');root.style.setProperty('--h3-progress',(index+1)/moments.length)};const observer=new IntersectionObserver((entries)=>{const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];if(visible)activate(moments.indexOf(visible.target))},{rootMargin:'-24% 0px -48% 0px',threshold:[0,.25,.5,.75]});moments.forEach(moment=>observer.observe(moment));buttons.forEach((button,index)=>button.addEventListener('click',()=>moments[index].scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'})));activate(0);instances.set(root,{observer,activate,moments})};const resolveRoot=(target)=>target?.matches?.('[data-h3-narrative]')?target:target?.querySelector?.('[data-h3-narrative]');document.querySelectorAll('[data-h3-narrative]').forEach(init);document.addEventListener('shopify:section:load',(event)=>init(resolveRoot(event.target)));document.addEventListener('shopify:section:unload',(event)=>{const root=resolveRoot(event.target),instance=root&&instances.get(root);instance?.observer.disconnect();if(root)instances.delete(root)});document.addEventListener('shopify:block:select',(event)=>{const block=document.querySelector(`[data-block-id="${event.detail.blockId}"]`),root=block?.closest('[data-h3-narrative]'),instance=root&&instances.get(root);if(!block||!instance)return;const index=instance.moments.indexOf(block);instance.activate(index);block.scrollIntoView({behavior:'smooth',block:'center'})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-two-placeholder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.h3Ready === 'true') return;
      root.dataset.h3Ready = 'true';
      const slides = [...root.querySelectorAll('[data-h3-slide]')];
      const dots = [...root.querySelectorAll('[data-h3-dot]')];
      const interval = Number(root.dataset.h3Interval) || 6500;
      const autoplay = root.dataset.h3Autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = 0;
      let timer = 0;
      let pointerStart = null;
      const restartCopy = () => {
        root.classList.remove('is-copy-active');
        void root.offsetWidth;
        requestAnimationFrame(() => root.classList.add('is-copy-active'));
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) { restartCopy(); observer.disconnect(); } });
      }, { threshold: .25 });
      observer.observe(root);
      const schedule = () => {
        clearTimeout(timer);
        if (slides.length > 1 && autoplay && !root.matches(':hover') && document.visibilityState === 'visible') timer = window.setTimeout(() => show(active + 1), interval);
      };
      const show = (next) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, index) => {
          const selected = index === active;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
          const bar = dot.querySelector('span');
          if (selected && bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        restartCopy();
        schedule();
      };
      root.querySelector('[data-h3-prev]')?.addEventListener('click', () => show(active - 1));
      root.querySelector('[data-h3-next]')?.addEventListener('click', () => show(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      root.addEventListener('mouseenter', () => { root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('mouseleave', () => { root.classList.remove('is-paused'); schedule(); });
      root.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
      root.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) > 45 && slides.length > 1) show(active + (distance < 0 ? 1 : -1));
      });
      root.addEventListener('pointermove', (event) => {
        if (matchMedia('(max-width:860px)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = root.getBoundingClientRect();
        root.style.setProperty('--h3-shift-x', `${(((event.clientX - rect.left) / rect.width - .5) * -15).toFixed(2)}px`);
        root.style.setProperty('--h3-shift-y', `${(((event.clientY - rect.top) / rect.height - .5) * -9).toFixed(2)}px`);
      });
      root.addEventListener('pointerleave', () => {
        root.classList.remove('is-paused');
        root.style.setProperty('--h3-shift-x', '0px');
        root.style.setProperty('--h3-shift-y', '0px');
        schedule();
      });
      document.addEventListener('visibilitychange', schedule);
      if (slides.length > 1) show(0);
    };
    document.querySelectorAll('[data-h3-story]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-h3-story]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
